import React from "react";

import styles from "./LoadingModal.module.css";

interface LoadingModalProps {
    title: string
    subtitle: string
}

/**
 * Blocking progress dialog for an operation that must not be interrupted half way, such as
 * restoring an assistant's configuration. Deliberately offers no way to dismiss it.
 */
export const LoadingModal: React.FC<LoadingModalProps> = ({title, subtitle}) => (
    <div className={styles.wrapper} role="status" aria-live="polite">
        <div className={styles.spinner} aria-hidden="true"/>
        <span className={styles.title}>{title}</span>
        <span className={styles.subtitle}>{subtitle}</span>
    </div>
);
